import React, { useReducer } from 'react';

const UserContext = React.createContext();
const _userState = {
    users :[],
    groups :[]
};

function userReducer(state , {type , data}){
    switch (type) {
        case 'set_users':
            return{...state , users : data };
        case 'set_groups':
            return{...state , groups : data };
        default:
            break;
    }
}
const FetchRequest = (url ,method ,headers , body)=>{
    return  new Promise((resolve,reject)=>{
    fetch(url ,  {method , headers ,body})
        .then(response=>{
            return response.json();
        })
        .then(({data})=>{
            return resolve(data[0]);
        })
        .catch(err=>{
            return reject(err);
        });
    });
};

const UserProvider = ({ children }) => {
    const [userState, dispatch ] = useReducer(userReducer , _userState);
    async function GetCognitoGroups(){
        try{
            const groups = await FetchRequest(process.env.REACT_APP_BACKEND_USER_API_ENDPOINT + "/groups",'GET',{});
            dispatch({ type : 'set_groups' , data : groups });
            return true;
        }
        catch(err){
            console.log(err);
            return false;
        }
    }
    async function GetCognitoUsers(){
        try{
            const users = await FetchRequest(process.env.REACT_APP_BACKEND_USER_API_ENDPOINT + "/users",'GET',{});
            dispatch({ type : 'set_users' , data : users });
            return true;
        }
        catch(err){
            console.log(err);
            return false;
        }
    }
    async function AddCognitoUser(users){
        const headers = {
            "content-type" : "application/json"
        };
        const body = {
            users
        };
        try{
            await FetchRequest(process.env.REACT_APP_BACKEND_USER_API_ENDPOINT + "/users",'POST',headers ,JSON.stringify(body) );
            return true;
        }
        catch(err){
            console.log(err);
            return false;
        }
    }
    return (
        <UserContext.Provider value={{ userState ,AddCognitoUser ,GetCognitoGroups , GetCognitoUsers }}>
            {children}
        </UserContext.Provider>
    );
};
export { UserContext , UserProvider};